<template>
  <div>TrangSuaDanhMucMenuHeThong</div>
</template>

<script>
export default {
  name: "TrangSuaDanhMucMenuHeThong"
};
</script>


